// extracted by mini-css-extract-plugin
export default {"tableDrag":"roadmap-table-drag-sash-module__tableDrag__dirbD3R","tableHeaderDrag":"roadmap-table-drag-sash-module__tableHeaderDrag__iZtHNs1"};